import { cn } from "../libs/utils";

const Divider = ({ className }: { className?: string }) => {
  return <div className={cn("h-px w-full bg-gray-200", className)} />;
};

export { Divider };
